module.exports = __webpack_public_path__ + "static/media/LightShowNoBoard.b835ab0f.logo";